<div class="d-flex flex-wrap align-content-center justify-content-center login">
  <section id="wrapper" class="login-register login-sidebar">
    <div class="login-box card">
      <div class="card-body">
        <form
          [formGroup]="loginForm"
          (ngSubmit)="login()"
          class="form-horizontal form-material"
          id="loginform"
          novalidate
        >
          <a href="javascript:void(0)" class="text-center db logo-container">
            <img src="" alt="" />
          </a>
          <h3 class="box-title m-t-40 m-b-0">
            DISTRIBUIDOR EL PREFERIDO
          </h3>

          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="loginForm.controls['email']"
                [controlName]="'Usuario'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="email"
                  placeholder="Usuario"
                />
              </app-form-error-wrapper>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="loginForm.controls['password']"
                [controlName]="'Password'"
              >
                <input
                  class="form-control"
                  type="password"
                  formControlName="password"
                  placeholder="Password"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12 d-flex justify-content-between">
              <div class="custom-control custom-checkbox pull-left p-t-0">
                <input
                  id="checkbox-signup"
                  class="custom-control-input"
                  type="checkbox"
                />
                <label for="checkbox-signup" class="custom-control-label">
                  Mantener mi sesión iniciada?
                </label>
              </div>
              <span class="pull-right">
                Olvido
                <a href="javascript:void(0)" id="to-recover"> Contraseña</a>?
              </span>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="loginForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'INGRESAR'"
                ></app-button-loader>
              </button>
            </div>
          </div>
          <div class="form-group m-b-0">
            <div class="col-sm-12 text-center">
             
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</div>
